import './style/index.js';

import _Switch from './Switch';

export type { SwitchProps } from './Switch';
export * from './type';

export const Switch = _Switch;
export default Switch;
